import React from "react";
import { AdminContainer } from "../components/layouts";
import MaterialTable from "material-table";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import api from "../api";
import tableIcons from "../components/tableIcons";
import {
  apiCollectionToRowResponse,
  rowQueryToApiParams
} from "../modules/tableQuery";
import { renderTableLink } from "../components/renderTableCell";
import debounce from "lodash/debounce";
import { Chip } from "@material-ui/core";

export default function IdentityListPage() {
  const theme = useTheme();
  const history = useHistory();
  const tableRef = React.createRef();
  const lastQueryRef = React.useRef("");

  const columns = React.useMemo(() => makeColumns(theme), [theme]);

  const fetchData = React.useCallback(
    debounce((q, resolve) => {
      const queryStr = JSON.stringify(q);
      if (lastQueryRef.current === queryStr) return resolve([]);
      lastQueryRef.current = queryStr;

      const params = rowQueryToApiParams(q);

      // Map field names for backend compatibility
      if (q.orderBy) {
        const orderByMap = {
          customersCount: "customers_count"
        };

        if (orderByMap[q.orderBy.field]) {
          params.orderBy = orderByMap[q.orderBy.field];
          params.orderDirection = q.orderDirection || "asc";
        }
      }

      api
        .getIdentities(params)
        .then((resp) => resolve(apiCollectionToRowResponse(resp)));
    }, 300),
    []
  );

  return (
    <AdminContainer variant="list">
      <MaterialTable
        title="Identities"
        tableRef={tableRef}
        columns={columns}
        options={{
          emptyRowsWhenPaging: false,
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
          sorting: true,
          thirdSortClick: false
        }}
        data={(q) =>
          new Promise((resolve) => {
            fetchData(q, resolve);
          })
        }
        icons={tableIcons}
        onRowClick={(event, rowData) => {
          history.push(`/identities/${rowData.id}`);
        }}
      />
    </AdminContainer>
  );
}

function makeColumns(theme) {
  function renderStatus(status) {
    if (status === "verified")
      return <Chip size="small" label="Verified" color="primary" />;

    return <Chip size="small" label="Unverified" />;
  }

  return [
    {
      title: "ID",
      field: "id",
      defaultSort: "desc",
      width: 100,
      render: renderTableLink({ url: "/identities/", body: "id" })
    },
    {
      title: "First Name",
      field: "firstName",
      defaultSort: "asc",
      render: renderTableLink({ url: "/identities/", body: "firstName" })
    },
    {
      title: "Last Name",
      field: "lastName",
      defaultSort: "asc",
      render: renderTableLink({ url: "/identities/", body: "lastName" })
    },
    {
      title: "Status",
      field: "status",
      defaultSort: "asc",
      render: (rowData) => renderStatus(rowData.status)
    },
    {
      title: "Customers Count",
      field: "customersCount",
      type: "numeric",
      render: (rowData) => rowData.customersCount || 0
    }
  ];
}
